export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/android_app.9cdba36.svg";